import {  nobservice } from "@/api/services/masterService";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

// Define types for NOB
interface NOB {
  
    id: string,
    businessName: string,
    riskId: string,
    riskname:string,

}

// Define state type
interface NOBMasterState {
  loading: boolean;
  NOBList: NOB[];
  error?: string;
}

// Initial state with type safety
const initialState: NOBMasterState = {
  loading: false,
  NOBList: [],
  error: undefined,
};

// ✅ Fixed Async thunk with proper return type
export const fetchNOBMaster = createAsyncThunk<
  NOB[], 
  void, 
  { rejectValue: string }
>(
  "NOB/fetchNOBMaster",
  async (_, { rejectWithValue }) => {

    try {
      const response = await nobservice.getallNob();

      // If API returns { data: NOB[] }, extract `data`
      return response.data ? response.data : response;
    } catch (error: any) {
      return rejectWithValue(error.message || "Failed to fetch NOB data");
    }
  }
);

// Create slice with strong typing
const NOBMasterSlice = createSlice({
  name: "NOBMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNOBMaster.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchNOBMaster.fulfilled, (state, action: PayloadAction<NOB[]>) => {
        state.NOBList = action.payload;
        state.loading = false;
      })
      .addCase(fetchNOBMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

// Export reducer
export default NOBMasterSlice.reducer;
